import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { persistReducer, persistStore } from "redux-persist";
import storage from "../Utils/storage";
import { RootReducer } from "./RootReducer";
import { rootSaga } from "./saga";
import { QueryClient } from "@tanstack/react-query";

const persistConfig = {
  key: "root",
  whitelist: ["token", "language", "userServices", "theme", "uploadedFiles", "incognito"],
  storage,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const sagaMiddleware = createSagaMiddleware({
  context: {
    queryClient,
  },
});

// @ts-ignore
const persistedReducer = persistReducer(persistConfig, RootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

//@ts-ignore
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
